var linkList = {
  goodsLink: '/product/search'
};
export default linkList;